import { useState, useEffect } from "react";
import { useGetAllModesQuery } from "src/services/ModeServices";

const useModes = () => {
    const [modes, setModes] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllModesQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setModes(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { modes, isDataLoading };
};

export default useModes;
